import React from 'react';
import { Grid } from "@mui/material";
import StatusCard from './StatusCard';
import { quoteDetailsList } from './quoteDetailsList';
import Labour from './Labour'
import Item from './Items'
import QuoteSummary from './QuoteSummary';
import JobCompletion from './JobCompletion';

const QuoteDetails = (props) => {
    return (
        <div>
            <Grid display='flex' justifyContent='space-around'>
                {quoteDetailsList?.map((item, JobList) => {
                    return <StatusCard item={item} />

                })}
            </Grid>
            <Labour/>
            <Item/>
            <QuoteSummary handleSetActive={props.handleSetActive}/>
            <JobCompletion/>
        </div>
    );
};

export default QuoteDetails;